/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFetchQuery } from './useFetchQuery'
import { AccessType } from '../API'
import { eventBySlug } from '../api/queries'
import { ACCESS_TYPES, EVENT_SHIRT_DETAILS } from '../constants/models'
import { Event } from '../models/API'
import { fetchQuery } from '../utils/ApiUtils'
import { jsonParse } from '../utils/ObjectUtil'

interface Props {
  slug: string | null | undefined
}

const useEventDetails = ({ slug }: Props) => {
  const {
    data: event,
    apiLoading,
    apiError,
  } = useFetchQuery(
    async () => {
      const { items } = (await fetchQuery('eventBySlug', eventBySlug, {
        slug,
      })) as unknown as { items: Event[] }

      if (items.length > 0)
        return {
          ...items[0],
          accessType: (items[0].accessType ??
            ACCESS_TYPES.PUBLIC) as AccessType,
          ...(items[0].subCategories && {
            subCategories: JSON.parse(
              JSON.parse(items[0].subCategories as string),
            ),
          }),
          shirtDetails: {
            ...EVENT_SHIRT_DETAILS,
            ...(items[0].shirtDetails && {
              ...JSON.parse(JSON.parse(items[0].shirtDetails as string)),
            }),
          },
          waiver: jsonParse(jsonParse(items[0].waiver as string)),
        }
      return undefined
    },
    [slug],
    'Fail to load event',
  )

  return { event, apiLoading, apiError }
}

export default useEventDetails
